/**
 * Configuration for Association of Community Publishers Career Center frontend.
 */
const jobiqoAppConfig = require('./../../src/jobiqo/config/app');
const mergeDeepRight = require('ramda/src/mergeDeepRight');

const defaultLocale = 'en';
const defaultRegion = 'us';
const locales = ['en'];
const priceConfig = {
  CURRENCY_PLACEMENT: 'before',
  USE_SPACING: false,
};

module.exports = mergeDeepRight(jobiqoAppConfig, {
  public: {
    TURBOPACK_BUILD: true,
    EURO_VAT_SYSTEM: false,
    SITENAME: 'Association of Community Publishers Career Center',
    SITE_DESCRIPTION:
      'Welcome to the new Association of Community Publishers Career Center, which is a member of TheJobNetwork™️ by Jobiqo. Members benefit from advanced Talent Acquisition and Recruitment Advertising technology that ACP has provided to the organization. ACP members receive a hiring profile page and an administrative dashboard. Jobiqo is an award-winning, globally recognized leader in AI-powered recruitment advertising solutions, providing complete job board platforms that turn reach into positive recruiting outcomes and grow recruitment advertising revenue.',
    DEFAULT_LOCALE: defaultLocale,
    DEFAULT_REGION: defaultRegion,
    LOCALES: locales,
    ASSETS: {
      logo: '/static/acp/logo.png',
      faviconsPath: '/static/acp',
    },
    OG_IMAGE: '/static/acp/web-app-manifest-512x512.png',
    AUTOCOMPLETE_WIDGET_OPTIONS: {
      country: ['us', 'ca'],
    },
    THEME: {
      colors: {
        primary: '#6885c2',
        secondary: '#df9d46',
      },
      logo: {
        minHeight: 60,
      },
    },
    PRICE_CONFIG: priceConfig,
    BLOG_FEATURE_ACTIVE: false,
    GA4_MEASUREMENT_IDS: ['G-04SBN34ERZ'],
    LINKEDIN_OAUTH_FEATURE_ACTIVE: true,
    FACEBOOK_OAUTH_FEATURE_ACTIVE: true,
    GOOGLE_OAUTH_FEATURE_ACTIVE: false,
    SOCIAL_LINKS: {
      facebook: 'https://www.facebook.com/communitypublishers',
      linkedin: 'https://www.linkedin.com/company/association-of-community-publishers',
    },
  },
});
